/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const caravan = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.133 12.667a.933.933 0 1 1-1.866 0m1.866 0a.933.933 0 1 0-1.866 0m1.866 0h.934a.943.943 0 0 0 .933-.934V9.867c0-.304-.095-.6-.271-.847m-3.462 3.647H9.4m-4.667 0a.933.933 0 0 1-1.866 0m1.866 0a.933.933 0 1 0-1.866 0m1.866 0H9.4m-6.533 0h-.934A.943.943 0 0 1 1 11.733V4.267C1 3.25 1.85 2.4 2.867 2.4h10.266C14.15 2.4 15 3.25 15 4.267c0 1.016-.85 1.866-1.867 1.866h-.466m2.062 2.887-2.062-2.887m2.062 2.887H9.4m0 3.647V9.02m3.267-2.887H9.4V9.02"
    />
  </svg>
)
export default caravan
